import React from 'react';
import {observer} from 'mobx-react';
import {Checkbox} from 'components';
import {FormattedMessage} from 'react-intl';
import _ from 'lodash';

const LocationTable = observer(({uiState}) => {
  const {currentHoliday, locations} = uiState;

  if (currentHoliday.locationIds === null) return null;

  const locationRows = locations.map((location) => (
    <label key={location.id} className="clearfix table py1 clickable">
      <div className="col-1 table-cell align-middle pr1">
        <Checkbox value={location.id}
                  checked={currentHoliday.locationIds.includes(location.id)}
                  onChange={e => uiState.handleLocationToggle(e)}/>
      </div>
      <div className="col-6 table-cell align-middle">
        {location.name}
      </div>
      <div className="col-5 table-cell align-middle waterloo">{location.city}</div>
    </label>
  ));

  return (
    <div className="clearfix table py1">
      <div className="col-5 table-cell"/>
      <div className="col-7 table-cell">
        <div className="p1 border rounded">
          {locationRows}
        </div>
      </div>
    </div>
  );
});

const HolidayLocationSelector = observer(({uiState}) => {
  const {currentHoliday} = uiState;

  const locationIds = currentHoliday.locationIds;
  return (
    <div>
      <div className="clearfix table py1">
        <div className="col-5 table-cell align-top">
          <FormattedMessage id='time_off.holidays.This Holiday is For'/>
        </div>
        <div className="col-7 table-cell">
          <div className="Radio-button pb1">
            <label className="table-cell align-middle">
              <input type="radio" name="locations" value="all"
                      checked={locationIds === null}
                      onChange={e => uiState.onAllEmployeesChange(e.target.value)} />
              <span className="Radio-button-circle"></span>
              <FormattedMessage id='time_off.holidays.All Employees'/>
            </label>
          </div>
          <div className="Radio-button pt1">
            <label className="table-cell align-middle">
              <input type="radio" name="locations" value="some"
                      checked={locationIds !== null}
                      onChange={e => uiState.onAllEmployeesChange(e.target.value)} />
              <span className="Radio-button-circle"></span>
              <FormattedMessage id='time_off.holidays.Some Employees'/>
            </label>
          </div>
        </div>
      </div>
      <LocationTable uiState={uiState}/>
    </div>
  );
});

export default HolidayLocationSelector;
